
import { Component, Prop, Vue } from 'nuxt-property-decorator'

type ParamsObject = {
  [key: string]: string,
}

@Component
export default class BlogShare extends Vue {
  @Prop({ required: true }) readonly layout!: string
  @Prop({ required: true }) readonly quote!: string

  get layoutClassName () {
    return `post-share--${this.layout}`
  }

  get routePath () {
    return this.$route.path
  }

  get encodedFullPath () {
    const url = `${this.$config.BASE_URL}${this.routePath}`
    return encodeURIComponent(url)
  }

  get facebookSharerUrl () {
    const base = 'https://www.facebook.com/sharer.php'
    const params = {
      u: this.encodedFullPath,
      quote: this.encodedQuote,
    }

    return this.formatUrl(base, params)
  }

  get twitterSharerUrl () {
    const base = 'https://twitter.com/intent/tweet'
    const params = {
      url: this.encodedFullPath,
      via: 'alao_ch',
      text: this.encodedQuote,
    }

    return this.formatUrl(base, params)
  }

  get linkedinSharerUrl () {
    const base = 'https://www.linkedin.com/sharing/share-offsite/'
    const params = {
      url: this.encodedFullPath,
    }

    return this.formatUrl(base, params)
  }

  get encodedQuote () {
    return encodeURIComponent(this.quote)
  }

  formatUrl (baseUrl: string, queryParams: ParamsObject): string {
    const queryParamsStr = this.paramsObjectToQueryString(queryParams)

    return `${baseUrl}?${queryParamsStr}`
  }

  paramsObjectToQueryString (params: ParamsObject): string {
    return Object.keys(params).map((key) => {
      return `${key}=${params[key]}`
    }).join('&')
  }
}
